import React from 'react'

import AccountBreadCrumbs from './partials/AccountBreadCrumbs'
import PortalOrdersBreadCrumbs from './partials/PortalOrdersBreadCrumbs'
import SettingsBreadCrumbs from './partials/SettingsBreadCrumbs'
import StockBreadCrumbs from './partials/StockBreadCrumbs'
import VehicleBreadCrumbs from './partials/VehicleBreadCrumbs'
import WorkOrdersBreadCrumbs from './partials/WorkOrdersBreadCrumbs'
import TendersBreadCrumbs from './partials/TendersBreadCrumbs'
import StatsBreadCrumbs from './partials/StatsBreadCrumbs'
import ProposalBreadCrumbs from './partials/AppointmentProposalBreadCrumbs'
import VehicleSalesBreadCrumbs from './partials/VehicleSalesBreadCrumbs'
import CourtesyVehiclesBreadCrumbs from './partials/CourtesyVehiclesBreadCrumbs'
import RentalVehiclesBreadCrumbs from './partials/RentalVehiclesBreadCrumbs'
import CRMBreadCrumbs from './partials/CRMBreadCrumbs'
import HistoryBreadCrumbs from './partials/HistoryBreadCrumbs'
import FinancialBreadCrumbs from './partials/FinancialBreadCrumbs'
import ReportingBreadCrumbs from './partials/ReportingBreadCrumbs'
import WholesalerBreadCrumbs from './partials/WholesalerBreadcrumbs'
import ConceptAppBreadCrumbs from './partials/ConceptAppBreadCrumbs'
import TyreWarrantyBreadCrumbs from './partials/TyreWarrantyBreadCrumbs'
import ProductWarrantyClaimBreadCrumbs from './partials/ProductWarrantyClaimsBreadCrumbs'
import RefurbishmentBreadCrumbs from './partials/RefurbishmentBreadCrumbs'
import SupplierOrdersBreadCrumbs from './partials/SupplierOrdersBreadCrumbs'

export const ApplicationBreadCrumbs: React.FC<{}> = () => {
  return (
    <>
      <AccountBreadCrumbs />
      <ConceptAppBreadCrumbs />
      <RefurbishmentBreadCrumbs />
      <TyreWarrantyBreadCrumbs />
      <ProposalBreadCrumbs />
      <VehicleBreadCrumbs />
      <PortalOrdersBreadCrumbs />
      <SupplierOrdersBreadCrumbs />
      <WorkOrdersBreadCrumbs />
      <StockBreadCrumbs />
      <SettingsBreadCrumbs />
      <StatsBreadCrumbs />
      <TendersBreadCrumbs />
      <VehicleSalesBreadCrumbs />
      <CourtesyVehiclesBreadCrumbs />
      <RentalVehiclesBreadCrumbs />
      <CRMBreadCrumbs />
      <HistoryBreadCrumbs />
      <FinancialBreadCrumbs />
      <ReportingBreadCrumbs />
      <WholesalerBreadCrumbs />
      <ProductWarrantyClaimBreadCrumbs />
    </>
  )
}

ApplicationBreadCrumbs.displayName = 'ApplicationBreadCrumbs'

export default ApplicationBreadCrumbs
